<template>
  <!-- 表格 -->
  <div class="customTable-box">
    <div class="table border-top-2 border-left-2 border-right-2">
      <!-- 标题 -->
      <div class="t-header">
        <!-- 收费代码 -->
        <div class="charge-box border-bottom-2  border-right-2">
          <div class="title">
            <div class="top">收费代码</div>
            <div class="bottom">Charge Code</div>
          </div>
          <!-- 收费代码内容 -->
          <div class="content border-top-2">
           
          </div>
        </div>
        <!-- 项目 -->
        <div class="item-box border-bottom-2  border-right-2">
          <div class="title-box">
            <div class="title1 border-bottom-2">
              <div class="">项目</div>
            </div>
            <div class="title2 border-bottom-2">
              <div class="">Item</div>
            </div>
          </div>
          <!-- 项目内容 -->
          <div class="content">
            WeMeet机构会员
          </div>
        </div>
        <!-- 摘要 -->
        <!-- <div class="item-box border-bottom-2  border-right-2">
          <div class="title-box">
            <div class="title1 border-bottom-2">
              <div class="">摘要</div>
            </div>
            <div class="title2 border-bottom-2">
              <div class="">Description</div>
            </div>
          </div>
          <div class="content">
            WeMeet机构会员
          </div>
        </div> -->
        <!-- 小计（人民币） -->
        <div class="charge-box border-bottom-2">
          <div class="title">
            <div class="top">小计（人民币）</div>
            <div class="bottom">Sub-Total（RMB）</div>
          </div>
          <!-- 小计（人民币）内容 -->
          <div class="content border-top-2">
            9,999.00
          </div>
        </div>
      </div>
      <!-- 尾部 -->
      <div class="t-footer border-bottom-2">
        <div class="content">
          合计Total
        </div>
        <div class="content">
          9,999.00
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'customTable',
  props: {},
  components: {},
  data() {
    return {}
  },
  methods: {},
  mounted() { }
}
</script>
<style lang="less" scoped>
.customTable-box {
  margin-top: 57px;
  color: #000000;
  font-size: 20px;
  .table {
    box-sizing: border-box;
    font-size:20px;
    .t-header {
      display: flex;

      .charge-box {
        display: flex;
        flex-flow: column wrap;
        flex: 2;

        .title {
          display: flex;
          flex-flow: column wrap;
          align-items: center;
          justify-content: center;
          text-align: center;
          height: 70px;
          padding: 0 5px;
          box-sizing: border-box;

          .bottom {
            margin-top: 3px;
          }
        }

        .content {
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          min-height: 180px;
          padding: 5px;
          font-weight: 700;
          box-sizing: border-box;
          flex:1;
        }
      }

      .item-box {
        display: flex;
        flex-flow: column wrap;
        flex: 1;

        .title-box {
          display: flex;
          flex-flow: column wrap;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          height: 72px;

          .title1,
          .title2 {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            align-self: stretch;
            padding: 2px 4px;
          }

          .title2 {}
        }

        .content {
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          min-height: 180px;
          padding: 5px;
          font-weight: 700;
          box-sizing: border-box;
        }
      }
    }
    .t-footer {
      display: flex;
      padding:  5px;
      box-sizing: border-box;
      min-height: 60px;
      .content {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-right: 13px;
        font-weight: 700;
      }
    }
  }
}







.border-2 {
  border: 1px solid #000000;
}

.border-top-2 {
  border-top: 1px solid #000000;
}

.border-bottom-2 {
  border-bottom: 1px solid #000000;
}

.border-left-2 {
  border-left: 1px solid #000000;
}

.border-right-2 {
  border-right: 1px solid #000000;
}</style>